import { render, staticRenderFns } from "./create-ledger-account-modal.vue?vue&type=template&id=f993e354"
import script from "./create-ledger-account-modal.ts?vue&type=script&lang=js&external"
export * from "./create-ledger-account-modal.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports